import { render, staticRenderFns } from "./detail-google.vue?vue&type=template&id=87a7e0bc&"
import script from "./detail-google.vue?vue&type=script&lang=js&"
export * from "./detail-google.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports